import Button from '@/components/Button'
import Toast2 from '@/components/Toast2'
import useLicenseKey from '@/hooks/use-license-keys'
import { useNavigate } from '@/lib/router-dom'
import DexLeftComponent from '@/components/DexLeftComponent';
import configApi from '@/services/api/config.js'
import api from '@/services/api/licenseKeys.js'
import "@/translations/i18n"
import { getEnvAndDex } from "@/utils/get-env-and-dex"
import { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { useSelector } from 'react-redux'


const Login = () => {

	const {t} = useTranslation();
	const { goTo } = useNavigate();

	const [pageTitle, setPageTitle] = useState(t("SGTraDex Pitstop - Installation"))

	const version = useSelector(state => state.version.data)

	const installationLeftStyles = {
		backgroundImage: `url("./cover-login.jpg")`
	}

	/*=================================================
		Error Modal
	/================================================*/
	const [error, setError] = useState()
	function handleError(){
		setError()
	}

	/*=================================================
		API
	/================================================*/
	const [licenseKey, setLicenseKey] = useState("")
	const { currentItem, findOne, setCurrentItem, error: licenseKeyError } = useLicenseKey();

	async function fetchStatus() {
		const [error, data] = await configApi.checkStatus()

		if(error){
			return setError(error?.error?.message || "Unable to retrieve Config")
		}

		return data.pitstopConfigured
	}

	useEffect(()=>{
		fetchStatus().then(value=>{
			if (value === true) {
				goTo(`/login`)
			}
		}).catch(value=>{
			setError(value.error.message || "Unable to check for config.")
		})
	}, [])

	useEffect(()=>{
		setError(licenseKeyError)
	}, [licenseKeyError])

	/*=================================================
		Step
	/================================================*/
	const [steps, setSteps] = useState(['step 1', 'step 2', 'step 3'])
	const [step, setStep] = useState(1)


	function goToStep(newStep) {
		if (newStep < 1 || newStep > steps.length) {
			return
		}
		setStep(newStep)
	}

	function prevStep() {
		goToStep(step - 1)
	}

	function nextStep() {
		goToStep(step + 1)
	}

	/*=================================================
		Functions
	/================================================*/
	async function verifyLicense() {
		const findLicence = await findOne(licenseKey)
		if(findLicence){
			nextStep()
			return setCurrentItem(findLicence);
		}
	}

	function handleChange() {
		setCurrentItem();
		setLicenseKey();
		goToStep(1);
	}

	async function handleConfirm(){
		const [error, result] = await api.create({
			licenseKey: licenseKey
		})

		if (error) {
			return setError(error?.error?.message)
		}
		nextStep()
	}

	const loginLeftStyles = {
		backgroundImage: `url("./sgtradex-cover-login.png")`
	}

	/*=================================================
		Navigate
	/================================================*/

	function launchPitstop() {
		goTo(`/login`)
	}

	/*=================================================
		MultiDex
	/================================================*/
	const dex = getEnvAndDex();

	return (
		<>
			<div className='layout-login'>
				<DexLeftComponent />
				<div className='layout-login__right'>
					<div className='installation-box'>
						{
							(step === 1 || step === 2) && (
								<>
									<div className='installation-box__title'>{t("almostUp")}</div>
									<div className='installation-box__desc'>{t("enterLicense")}</div>
								</>
							)
						}
						{
							(step === 3) && (
								<>
									<div className='installation-box__title'>{t("verifiedLicence")}</div>
									<div className='installation-box__desc'>{t("allDone")}</div>
								</>
							)
						}

						<div className='installation-box__content'>
							{
								(step === 1) && (
									<div className='installation-box__form__cols'>
										{/* <div className='installation-box__form__col'>
											{
												error && (
													<span className='installation-box__form__text--medium installation-box__form__text--error'><IconWarning/>  {error}</span>
												)
											}
										</div> */}
										<div className='installation-box__form__col'>
											<input name='installationKey' type='text' placeholder="xxx - xxx - xxx" value={licenseKey} onChange={(e)=>setLicenseKey(e.target.value)} />
											<span className="installation-box__form__desc">{t("cantFindKey")} <span className="installation-box__form__desc--medium link link--color">{t("contactUs")}</span></span>
										</div>
										<div className='installation-box__form__actions'>
											<Button round full maxWidth={240} text={t("register")} submit={()=>verifyLicense()} />
										</div>
									</div>
								)
							}
							{
								(step === 2 || step === 3) && (
									<div className='installation-box__form__cols'>
										<div className='installation-box__form__col'>
											<span className="installation-box__form__desc installation-box__form__text--medium installation-box__form__text--grey">{t("licenseRegistered")}</span>
											<div className="installation-box__form__verification">
												<div className="installation-box__form__verification__avatar" style={{ backgroundImage: `url(${currentItem?.org.iconUrl})` }}></div>
												<div className="installation-box__form__verification__text--name">{currentItem?.org.name}</div>
												{
													(step === 2) && (
														<div className="installation-box__form__verification__text link--color link" onClick={()=>handleChange() }>Change</div>
													)
												}
											</div>
										</div>
										<div className='installation-box__form__actions'>
											{
												(step === 2) && (
													<Button round full maxWidth={240} text={t("confirm")} submit={()=>{
														handleConfirm()
													}
													} />
												)
											}
											{
												(step === 3) && (
													<Button round full maxWidth={240} text={t("launchPitstop")} submit={()=>launchPitstop()} />
												)
											}
										</div>
									</div>
								)
							}

						</div>
					</div>
				</div>
				<div className="version__no">
					v{version?.pitstopVersion}
				</div>
			</div>
			<Toast2 show={error} errorMessage={error} close={()=>{handleError()}} />
		</>
	)
}
export default Login
